import { useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  NavLink,
} from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from './auth/AdminAuthContext';
import { supabase } from './supabase';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Businesses from './pages/Businesses';
import BusinessDetail from './pages/BusinessDetail';
import Leads from './pages/Leads';
import './App.css';

function RequireAdmin() {
  const { loading, isAdmin, session } = useAdminAuth();

  useEffect(() => {
    if (!loading && session && !isAdmin) {
      supabase.auth.signOut();
    }
  }, [loading, session, isAdmin]);

  if (loading) {
    return (
      <div className="app-loading">
        <p>Loading…</p>
      </div>
    );
  }
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

function DashboardLayout() {
  async function handleSignOut() {
    await supabase.auth.signOut();
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <span className="app-brand">ReplyFirst Admin</span>
        <nav className="app-nav">
          <NavLink
            to="/overview"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            Overview
          </NavLink>
          <NavLink
            to="/businesses"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            Businesses
          </NavLink>
          <NavLink
            to="/leads"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            Leads
          </NavLink>
        </nav>
        <button type="button" className="sign-out" onClick={handleSignOut}>
          Sign out
        </button>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}

function LoginRoute() {
  const { loading, isAdmin } = useAdminAuth();
  if (loading) {
    return (
      <div className="app-loading">
        <p>Loading…</p>
      </div>
    );
  }
  if (isAdmin) {
    return <Navigate to="/overview" replace />;
  }
  return <Login />;
}

function App() {
  return (
    <AdminAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route element={<RequireAdmin />}>
            <Route element={<DashboardLayout />}>
              <Route path="/" element={<Navigate to="/overview" replace />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/businesses" element={<Businesses />} />
              <Route path="/businesses/:id" element={<BusinessDetail />} />
              <Route path="/leads" element={<Leads />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Routes>
      </BrowserRouter>
    </AdminAuthProvider>
  );
}

export default App;
